/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { ISite } from '@/interfaces/siteSettings';
import { createModel } from 'ice';

export default createModel({
  state: {
    name: {},
    copyright: {},
    icon: '',
    logo: '',
    miniappDefaultIcon: '',
    miniappDefaultRelativeIcon: ''
  } as ISite,
  reducers: {
    updateCurrentSiteSettings(prevState: ISite, payload) {
      prevState.name = payload.name;
      prevState.copyright = payload.copyright;
      prevState.icon = payload.icon;
      prevState.logo = payload.logo;
      prevState.miniappDefaultIcon = payload.miniappDefaultIcon;
      prevState.miniappDefaultRelativeIcon = payload.miniappDefaultRelativeIcon;
    },
  },
});
